import type { NextPage } from "next";
import React, { useEffect, Fragment } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import NightsStayIcon from "@material-ui/icons/NightsStay";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import MUILink from "@material-ui/core/Link";
import useDarkMode from "use-dark-mode";

const Header: NextPage = () => {
  useEffect(() => {
    AOS.init({
      easing: "ease-out-cubic",
      once: true,
      offset: 50,
    });
  });
  const { value: isDark, toggle: toggleDarkMode } = useDarkMode();

  return (
    <>
      {/* <MUILink
        style={
          isDark
            ? { textDecoration: "none", color: "white" }
            : { textDecoration: "none", color: "black" }
        }
        onClick={toggleDarkMode}
      >
        {isDark ? <WbSunnyIcon /> : <NightsStayIcon />}
      </MUILink> */}
      <h1 className="text-shadow title">
        <span>👋 Hello,</span>
        <span className="title-content title-second">I am Keyur Italiya</span>
      </h1>
    </>
  );
};

export default Header;
